import { z } from 'zod';
import { PositionSchema } from './base';
import { HAActionSchema, HAConditionSchema, HADelaySchema, HATriggerSchema, HAVariablesSchema, HAWaitSchema, } from './ha-schemas';
// ============================================
// TRIGGER NODE
// ============================================
export const TriggerNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('trigger'),
    position: PositionSchema,
    data: HATriggerSchema,
});
// ============================================
// CONDITION NODE
// ============================================
export const ConditionNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('condition'),
    position: PositionSchema,
    data: HAConditionSchema,
});
// ============================================
// ACTION NODE
// ============================================
export const ActionNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('action'),
    position: PositionSchema,
    data: HAActionSchema,
});
// ============================================
// DELAY NODE
// ============================================
export const DelayNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('delay'),
    position: PositionSchema,
    data: HADelaySchema,
});
// ============================================
// WAIT NODE
// ============================================
export const WaitNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('wait'),
    position: PositionSchema,
    data: HAWaitSchema,
});
// ============================================
// SET VARIABLES NODE
// ============================================
export const SetVariablesNodeSchema = z.looseObject({
    id: z.string().min(1),
    type: z.literal('set_variables'),
    position: PositionSchema,
    data: HAVariablesSchema,
});
// ============================================
// DISCRIMINATED UNION
// ============================================
/**
 * Discriminated union of all node types
 * The 'type' field determines which schema is used for validation
 */
export const NodeSchema = z.discriminatedUnion('type', [
    TriggerNodeSchema,
    ConditionNodeSchema,
    ActionNodeSchema,
    DelayNodeSchema,
    WaitNodeSchema,
    SetVariablesNodeSchema,
]);
/**
 * Type guard functions for narrowing node types
 */
export function isTriggerNode(node) {
    return node.type === 'trigger';
}
export function isConditionNode(node) {
    return node.type === 'condition';
}
export function isActionNode(node) {
    return node.type === 'action';
}
export function isDelayNode(node) {
    return node.type === 'delay';
}
export function isWaitNode(node) {
    return node.type === 'wait';
}
export function isSetVariablesNode(node) {
    return node.type === 'set_variables';
}
//# sourceMappingURL=nodes.js.map